(function($){
  var $ = jQuery = $;

  theme.icons = {
    left: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
    right: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
    close: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
    chevronLeft: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M14.298 18.187l1.061-1.061-5.127-5.126 5.127-5.126-1.061-1.061-6.187 6.187z"></path></svg>',
    chevronRight: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M9.702 18.187l-1.061-1.061 5.127-5.126-5.127-5.126 1.061-1.061 6.187 6.187z"></path></svg>',
    chevronDown: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/><path d="M0-.75h24v24H0z" fill="none"/></svg>',
    tick: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>'
  };

  theme.Shopify = {
    formatMoney: function(t, r) {
      function e(t, r) {
        return void 0 === t ? r : t
      }
      function a(t, r, a, o) {
        if (r = e(r, 2),
            a = e(a, ","),
            o = e(o, "."),
            isNaN(t) || null == t)
          return 0;
        t = (t / 100).toFixed(r);
        var n = t.split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "")
      }
      "string" == typeof t && (t = t.replace(".", ""));
      var o = ""
      , n = /\{\{\s*(\w+)\s*\}\}/
      , i = r || this.money_format;
      switch (i.match(n)[1]) {
        case "amount":
          o = a(t, 2);
          break;
        case "amount_no_decimals":
          o = a(t, 0);
          break;
        case "amount_with_comma_separator":
          o = a(t, 2, ".", ",");
          break;
        case "amount_with_space_separator":
          o = a(t, 2, " ", ",");
          break;
        case "amount_with_period_and_space_separator":
          o = a(t, 2, " ", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          o = a(t, 0, ",", "");
          break;
        case "amount_no_decimals_with_space_separator":
          o = a(t, 0, " ", "");
          break;
        case "amount_with_space_separator":
          o = a(t, 2, " ", "");
          break;
        case "amount_with_apostrophe_separator":
          o = a(t, 2, "'", ".")
      }
      return i.replace(n, o)
    },
    formatImage: function(originalImageUrl, format) {
      return originalImageUrl.replace(/^(.*)\.([^\.]*)$/g, '$1_' + format + '.$2');
    }
  };

  // Get support Shopify features
  try {
    theme.Shopify.features = JSON.parse(document.documentElement.querySelector('#shopify-features').textContent);
  } catch (e) {
    theme.Shopify.features = {};
  }

  theme.Disclosure = (function() {
    var selectors = {
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };

    var classes = {
      listVisible: 'disclosure-list--visible'
    };

    function Disclosure($disclosure) {
      this.$container = $disclosure;
      this.cache = {};
      this._cacheSelectors();
      this._connectOptions();
      this._connectToggle();
      this._onFocusOut();
    }

    Disclosure.prototype = $.extend({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          $disclosureList: this.$container.find(selectors.disclosureList),
          $disclosureToggle: this.$container.find(selectors.disclosureToggle),
          $disclosureInput: this.$container.find(selectors.disclosureInput),
          $disclosureOptions: this.$container.find(selectors.disclosureOptions)
        };
      },

      _connectToggle: function() {
        this.cache.$disclosureToggle.on(
          'click',
          function(evt) {
            var ariaExpanded =
                $(evt.currentTarget).attr('aria-expanded') === 'true';
            $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

            this.cache.$disclosureList.toggleClass(classes.listVisible);
          }.bind(this)
        );
      },

      _connectOptions: function() {
        this.cache.$disclosureOptions.on(
          'click',
          function(evt) {
            evt.preventDefault();
            this._submitForm($(evt.currentTarget).data('value'));
          }.bind(this)
        );
      },

      _onFocusOut: function() {
        this.cache.$disclosureToggle.on(
          'focusout',
          function(evt) {
            var disclosureLostFocus =
                this.$container.has(evt.relatedTarget).length === 0;

            if (disclosureLostFocus) {
              this._hideList();
            }
          }.bind(this)
        );

        this.cache.$disclosureList.on(
          'focusout',
          function(evt) {
            var childInFocus =
                $(evt.currentTarget).has(evt.relatedTarget).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );

            if (isVisible && !childInFocus) {
              this._hideList();
            }
          }.bind(this)
        );

        this.$container.on(
          'keyup',
          function(evt) {
            if (evt.which !== 27) return; // escape
            this._hideList();
            this.cache.$disclosureToggle.focus();
          }.bind(this)
        );

        $('body').on(
          'click',
          function(evt) {
            var isOption = this.$container.has(evt.target).length > 0;
            var isVisible = this.cache.$disclosureList.hasClass(
              classes.listVisible
            );

            if (isVisible && !isOption) {
              this._hideList();
            }
          }.bind(this)
        );
      },

      _submitForm: function(value) {
        this.cache.$disclosureInput.val(value);
        this.$container.parents('form').submit();
      },

      _hideList: function() {
        this.cache.$disclosureList.removeClass(classes.listVisible);
        this.cache.$disclosureToggle.attr('aria-expanded', false);
      },

      unload: function() {
        this.cache.$disclosureOptions.off();
        this.cache.$disclosureToggle.off();
        this.cache.$disclosureList.off();
        this.$container.off();
      }
    });

    return Disclosure;
  })();

  theme.Sections = new function(){
    var _ = this;

    _._instances = [];
    _._sections = [];

    _.init = function(){
      $(document).on('shopify:section:load', function(e){
        // load a new section
        var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
        if(target) {
          _.sectionLoad(target);
        }
      }).on('shopify:section:unload', function(e){
        // unload existing section
        var target = _._themeSectionTargetFromShopifySectionTarget(e.target);
        if(target) {
          _.sectionUnload(target);
        }
      });
    }

    // register a type of section
    _.register = function(type, section){
      _._sections.push({ type: type, section: section });
      $('[data-section-type="'+type+'"]').each(function(){
        _.sectionLoad(this);
      });
    }

    // load in a section
    _.sectionLoad = function(target){
      var target = target;
      var section = _._sectionForTarget(target);
      if(section !== false) {
        _._instances.push({
          target: target,
          section: section
        });
        section.onSectionLoad(target);
        $(target).on('shopify:block:select', function(e){
          _._callWith(section, 'onBlockSelect', e.target);
        }).on('shopify:block:deselect', function(e){
          _._callWith(section, 'onBlockDeselect', e.target);
        });
      }
    }

    // unload a section
    _.sectionUnload = function(target){
      var instanceIndex = -1;
      for(var i=0; i<_._instances.length; i++) {
        if(_._instances[i].target == target) {
          instanceIndex = i;
        }
      }
      if(instanceIndex > -1) {
        $(target).off('shopify:block:select shopify:block:deselect');
        _._callWith(_._instances[instanceIndex].section, 'onSectionUnload', target);
        _._instances.splice(instanceIndex);
      }
    }

    // helpers
    _._callWith = function(object, method, param) {
      if(typeof object[method] === 'function') {
        object[method](param);
      }
    }

    _._themeSectionTargetFromShopifySectionTarget = function(target){
      var $target = $('[data-section-type]:first', target);
      if($target.length > 0) {
        return $target[0];
      } else {
        return false;
      }
    }

    _._sectionForTarget = function(target) {
      var type = $(target).attr('data-section-type');
      for(var i=0; i<_._sections.length; i++) {
        if(_._sections[i].type == type) {
          return _._sections[i].section;
        }
      }
      return false;
    }
  }

  // Loading third party scripts
  theme.scriptsLoaded = {};
  theme.loadScriptOnce = function(src, callback, beforeRun) {
    if(typeof theme.scriptsLoaded[src] === 'undefined') {
      theme.scriptsLoaded[src] = [];
      var tag = document.createElement('script');
      tag.src = src;

      if(beforeRun) {
        tag.async = false;
        beforeRun();
      }

      if(typeof callback === 'function') {
        theme.scriptsLoaded[src].push(callback);
        if (tag.readyState) { // IE, incl. IE9
          tag.onreadystatechange = (function() {
            if (tag.readyState == "loaded" || tag.readyState == "complete") {
              tag.onreadystatechange = null;
              for(var i = 0; i < theme.scriptsLoaded[this].length; i++) {
                theme.scriptsLoaded[this][i]();
              }
              theme.scriptsLoaded[this] = true;
            }
          }).bind(src);
        } else {
          tag.onload = (function() { // Other browsers
            for(var i = 0; i < theme.scriptsLoaded[this].length; i++) {
              theme.scriptsLoaded[this][i]();
            }
            theme.scriptsLoaded[this] = true;
          }).bind(src);
        }
      }

      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      return true;
    } else if(typeof theme.scriptsLoaded[src] === 'object' && typeof callback === 'function') {
      theme.scriptsLoaded[src].push(callback);
    } else {
      if(typeof callback === 'function') {
        callback();
      }
      return false;
    }
  }

  theme.loadStyleOnce = function(src) {
    var srcWithoutProtocol = src.replace(/^https?:/, '');
    if(!document.querySelector('link[href="' + encodeURI(srcWithoutProtocol) + '"]')) {
      var tag = document.createElement('link');
      tag.href = srcWithoutProtocol;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      var firstTag = document.getElementsByTagName('link')[0];
      firstTag.parentNode.insertBefore(tag, firstTag);
    }
  }

  // Manage videos
  theme.VideoManager = new function(){
    var _ = this;

    // Youtube
    _.youtubeVars = {
      incrementor: 0,
      apiReady: false,
      videoData: {},
      toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)'
    };

    _.youtubeApiReady = function() {
      _.youtubeVars.apiReady = true;
      _._loadYoutubeVideos();
    }

    _._loadYoutubeVideos = function(container) {
      if($(_.youtubeVars.toProcessSelector, container).length) {
        if(_.youtubeVars.apiReady) {
          // play those videos
          $(_.youtubeVars.toProcessSelector, container).addClass('video--init').each(function(){
            _.youtubeVars.incrementor++;
            var containerId = 'theme-yt-video-'+_.youtubeVars.incrementor;
            var videoElement = $('<div>').attr('id', containerId).appendTo(this);
            var autoplay = $(this).data('video-autoplay');
            var player = new YT.Player(containerId, {
              height: '390',
              width: '640',
              videoId: $(this).data('video-id'),
              playerVars: {
                iv_load_policy: 3,
                modestbranding: 1,
                autoplay: autoplay ? 1 : 0,
                rel: 0,
                showinfo: 0
              },
              events: {
                onReady: _._onYoutubePlayerReady.bind({ autoplay: autoplay }),
                onStateChange: _._onYoutubePlayerStateChange
              }
            });
            _.youtubeVars.videoData[containerId] = {
              id: containerId,
              container: this,
              videoElement: videoElement,
              player: player
            };
          });
        } else {
          // load api
          theme.loadScriptOnce('https://www.youtube.com/iframe_api');
        }
      }
    }

    _._onYoutubePlayerReady = function(event) {
      event.target.setPlaybackQuality('hd1080');
      if(this.autoplay) {
        event.target.mute();
      }
    }

    _._onYoutubePlayerStateChange = function(event) {
    }

    _._getYoutubeVideoData = function(event) {
      return _.youtubeVars.videoData[event.target.h.id];
    }

    _._unloadYoutubeVideos = function(container) {
      for(var dataKey in _.youtubeVars.videoData) {
        var data = _.youtubeVars.videoData[dataKey];
        if($(container).find(data.container).length) {
          data.player.destroy();
          delete _.youtubeVars.videoData[dataKey];
          return;
        }
      }
    }

    // Vimeo
    _.vimeoVars = {
      incrementor: 0,
      apiReady: false,
      videoData: {},
      toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)'
    };

    _.vimeoApiReady = function() {
      _.vimeoVars.apiReady = true;
      _._loadVimeoVideos();
    }

    _._loadVimeoVideos = function(container) {
      if($(_.vimeoVars.toProcessSelector, container).length) {
        if(_.vimeoVars.apiReady) {
          // play those videos
          $(_.vimeoVars.toProcessSelector, container).addClass('video--init').each(function(){
            _.vimeoVars.incrementor++;
            var $this = $(this);
            var containerId = 'theme-vi-video-'+_.vimeoVars.incrementor;
            var videoElement = $('<div>').attr('id', containerId).appendTo(this);
            var autoplay = !!$(this).data('video-autoplay');
            var player = new Vimeo.Player(containerId, {
              url: $(this).data('video-url'),
              width: 640,
              loop: false,
              autoplay: autoplay
            });
            player.ready().then(function(){
              if(autoplay) {
                player.setVolume(0);
              }
              if(player.element && player.element.width && player.element.height) {
                var ratio = parseInt(player.element.height) / parseInt(player.element.width);
                $this.css('padding-top', (ratio*100) + '%');
              }
            });
            _.vimeoVars.videoData[containerId] = {
              id: containerId,
              container: this,
              videoElement: videoElement,
              player: player,
              autoPlay: autoplay
            };
          });
        } else {
          // load api
          if(window.define) {
            // workaround for third parties using RequireJS
            theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function(){
              _.vimeoVars.apiReady = true;
              _._loadVimeoVideos();
              window.define = window.tempDefine;
            }, function(){
              window.tempDefine = window.define;
              window.define = null;
            });
          } else {
            theme.loadScriptOnce('https://player.vimeo.com/api/player.js', function(){
              _.vimeoVars.apiReady = true;
              _._loadVimeoVideos();
            });
          }
        }
      }
    }

    _._unloadVimeoVideos = function(container) {
      for(var dataKey in _.vimeoVars.videoData) {
        var data = _.vimeoVars.videoData[dataKey];
        if($(container).find(data.container).length) {
          data.player.unload();
          delete _.vimeoVars.videoData[dataKey];
          return;
        }
      }
    }

    // Compatibility with Sections
    this.onSectionLoad = function(container){
      _._loadYoutubeVideos(container);
      _._loadVimeoVideos(container);

      // play button
      $('.video-container__play', container).on('click', function(evt){
        evt.preventDefault();
        // reveal
        var $cover = $(this).closest('.video-container__cover').addClass('video-container__cover--playing');
        // play
        var id = $cover.next().attr('id');
        if(id.indexOf('theme-yt-video') === 0) {
          _.youtubeVars.videoData[id].player.playVideo();
        } else {
          _.vimeoVars.videoData[id].player.play();
        }
      });
    }

    this.onSectionUnload = function(container){
      $('.video-container__play', container).off('click');
      _._unloadYoutubeVideos(container);
      _._unloadVimeoVideos(container);
    }
  }

  // Youtube API callback
  window.onYouTubeIframeAPIReady = function() {
    theme.VideoManager.youtubeApiReady();
  }

  // Product Media
  theme.ProductMedia = new function(){
    var _ = this;

    _._setupShopifyXr = function() {
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', _._setupShopifyXr.bind(this));
        return;
      }

      window.ShopifyXR.addModels(JSON.parse($(this).html()));
      window.ShopifyXR.setupXRElements();
    };

    this.init = function(container, callbacks){
      var callbacks = callbacks || {},
          _container = container;

      // necessary callbacks (before automatic behaviours)
      if(callbacks.onImageVisible) {
        $(container).on('mediaVisible', '.product-media--image', callbacks.onImageVisible);
      }

      if(callbacks.onImageHidden) {
        $(container).on('mediaHidden', '.product-media--image', callbacks.onImageHidden);
      }

      if(callbacks.onVideoVisible) {
        $(container).on('mediaVisible', '.product-media--video-loaded', callbacks.onVideoVisible);
      }

      if(callbacks.onVideoHidden) {
        $(container).on('mediaHidden', '.product-media--video-loaded', callbacks.onVideoHidden);
      }

      if(callbacks.onModelVisible) {
        $(container).on('mediaVisible', '.product-media--model-loaded', callbacks.onModelVisible);
      }

      $('model-viewer', container).each(function(){
        if(callbacks.onModelViewerPlay) {
          $(this).on('shopify_model_viewer_ui_toggle_play', callbacks.onModelViewerPlay);
        }
        if(callbacks.onModelViewerPause) {
          $(this).on('shopify_model_viewer_ui_toggle_pause', callbacks.onModelViewerPause);
        }
      });

      // when any media appears
      $(container).on('mediaVisible', '.product-media--video-loaded, .product-media--model-loaded', function(){
        // autoplay all media on larger screens
        if($(window).width() >= 768) {
          $(this).data('player').play();
        }
        // update view-in-space
        if($(this).hasClass('product-media--model')) {
          $('.view-in-space', _container).attr('data-shopify-model3d-id', $(this).data('model-id'));
        }
        // pause all other media
        $('.product-media').not(this).trigger('mediaHidden');
      });

      // when any media is hidden
      $(container).on('mediaHidden', '.product-media--video-loaded, .product-media--model-loaded', function(){
        // pause all media
        $(this).data('player').pause();
      });

      if(callbacks.onModelHidden) {
        $(container).on('mediaHidden', '.product-media--model-loaded', callbacks.onModelHidden);
      }// set up video media elements with a controller
      $(container).find('.product-media--video').each(function(index){
        var enableLooping = $(this).data('enable-video-looping'),
            $currentMedia = $(this),
            element = $(this).find('iframe, video')[0];
        if (element.tagName === 'VIDEO') {
          // set up a controller for Plyr video
          window.Shopify.loadFeatures([
            {
              name: 'video-ui',
              version: '1.0',
              onLoad: (function(){
                var playerObj = { playerType: 'html5', element: element };

                playerObj.play = (function(){
                  this.plyr.play();
                }).bind(playerObj);

                playerObj.pause = (function(){
                  this.plyr.pause();
                }).bind(playerObj);

                playerObj.destroy = (function(){
                  this.plyr.destroy();
                }).bind(playerObj);

                playerObj.plyr = new Shopify.Plyr(element, {
                  controls: [
                    'play',
                    'progress',
                    'mute',
                    'volume',
                    'play-large',
                    'fullscreen'
                  ],
                  loop: { active: enableLooping },
                  hideControlsOnPause: true,
                  iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
                  tooltips: { controls: false, seek: true }
                });
                $(this).data('player', playerObj).addClass('product-media--video-loaded');
                $currentMedia.find('.plyr__controls').addClass('swiper-no-swiping');

                // callbacks for Plyr playback
                $(element).on('playing', function(){
                  // pause other media
                  $('.product-media').not($currentMedia).trigger('mediaHidden');
                  // prevent bubbling inputs that can be used by carousels
                  $currentMedia.find('.plyr__controls').off('.themeMediaEventFix')
                  .on('keydown.themeMediaEventFix touchstart.themeMediaEventFix touchmove.themeMediaEventFix touchend.themeMediaEventFix mousedown.themeMediaEventFix mousemove.themeMediaEventFix mouseup.themeMediaEventFix', function(e){
                    e.stopPropagation();
                  });
                  if(callbacks.onPlyrPlay) {
                    callbacks.onPlyrPlay(playerObj);
                  }
                });
                $(element).on('pause ended', function(){
                  // remove event bubbling interceptor
                  $currentMedia.find('.plyr__controls').off('.themeMediaEventFix');
                  if(callbacks.onPlyrPause) {
                    callbacks.onPlyrPause(playerObj);
                  }
                });
                if(callbacks.onPlyrInit) {
                  callbacks.onPlyrInit(playerObj);
                }
              }).bind(this)
            }
          ]);
          theme.loadStyleOnce('https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css');

        } else if (element.tagName === 'IFRAME') {
          if (
            /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
              element.src
            )
          ) {
            // set up a controller for YouTube video
            var existingYTCB = window.onYouTubeIframeAPIReady;
            var loadYoutubeVideo = (function() {
              var playerObj = { playerType: 'youtube', element: element };
              var videoId = $(this).data('video-id');

              playerObj.player = new YT.Player(element, {
                videoId: videoId,
                events: {
                  onStateChange: function(event) {
                    if(event.data === YT.PlayerState.ENDED && enableLooping) {
                      event.target.seekTo(0);
                    }

                    if(event.data === YT.PlayerState.PLAYING) {
                      $('.product-media').not($currentMedia).trigger('mediaHidden');
                      if(callbacks.onYouTubePlay) {
                        callbacks.onYouTubePlay(playerObj);
                      }
                    }

                    if(event.data === YT.PlayerState.PAUSED && event.data === YT.PlayerState.ENDED) {
                      if(callbacks.onYouTubePause) {
                        callbacks.onYouTubePause(playerObj);
                      }
                    }
                  }
                }
              });

              playerObj.play = (function(){
                this.player.playVideo();
              }).bind(playerObj);

              playerObj.pause = (function(){
                this.player.pauseVideo();
              }).bind(playerObj);

              playerObj.destroy = (function(){
                this.player.destroy();
              }).bind(playerObj);

              $(this).data('player', playerObj).addClass('product-media--video-loaded');

              if(callbacks.onYouTubeInit) {
                callbacks.onYouTubeInit(playerObj);
              }
            }).bind(this);
            window.onYouTubeIframeAPIReady = function(){
              if(existingYTCB) {
                existingYTCB();
              }
              loadYoutubeVideo();
            }
            theme.loadScriptOnce('https://www.youtube.com/iframe_api');
          }
        }
      });

      // set up a 3d model when it first appears
      $(container).on('mediaVisible mediaVisibleInitial', '.product-media--model:not(.product-media--model-loaded):not(.product-media--model-loading)', function(e){
        var element = $(this).find('model-viewer')[0],
            $currentMedia = $(this),
            autoplay = e.type != 'mediaVisibleInitial';
        // do not run this twice
        $(this).addClass('product-media--model-loading');
        // load viewer
        theme.loadStyleOnce('https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css');
        window.Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: (function(evt){
              $(this).data('player', new Shopify.ModelViewerUI(element));
              // add mouseup event proxy to fix carousel swipe gestures
              $('<div class="theme-event-proxy">').on('mouseup', function(e){
                e.stopPropagation();
                e.preventDefault();
                var newEventTarget = $(e.currentTarget).closest('.product-media')[0];
                newEventTarget.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
              }).appendTo(
                $(this).find('.shopify-model-viewer-ui__controls-overlay')
              );
              // when playing or loading, prevent bubbling of down/up/move
              $(this).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function(){
                $(this).closest('.shopify-model-viewer-ui').on('keydown.themeMediaEventFix touchstart.themeMediaEventFix touchmove.themeMediaEventFix touchend.themeMediaEventFix mousedown.themeMediaEventFix mousemove.themeMediaEventFix mouseup.themeMediaEventFix', function(e){
                  e.stopPropagation();
                });
              }).on('shopify_model_viewer_ui_toggle_pause', function(){
                $(this).closest('.shopify-model-viewer-ui').off('.themeMediaEventFix');
              });
              // ensure play exclusivity
              $(this).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function(){
                $('.product-media').not($currentMedia).trigger('mediaHidden');
              });
              // set class and re-trigger visible event now loaded
              $(this).addClass('product-media--model-loaded').removeClass('product-media--model-loading');
              if(callbacks.onModelViewerInit) {
                callbacks.onModelViewerInit(element);
              }
              if(autoplay) {
                $(this).trigger('mediaVisible');
              }
            }).bind(this)
          }
        ]);
      });

      // load AR viewer
      if($('.model-json', container).length) {
        window.Shopify.loadFeatures([
          {
            name: 'shopify-xr',
            version: '1.0',
            onLoad: _._setupShopifyXr.bind($('.model-json', container))
          }
        ]);
      }

      // pause video when a 3d model is launched in AR
      $(document).on('shopify_xr_launch', function(){
        $('.product-media--video-loaded').each(function(){
          $(this).data('player').pause();
        });
      });

      // 3d model in first place - start in paused mode
      setTimeout((function(){
        $('.product-media:first', this).filter('.product-media--model').trigger('mediaVisibleInitial');
      }).bind(container), 50);
    }

    this.destroy = function(container){
      $(document).off('shopify_xr_launch');
      $(container).off('mediaVisible mediaVisibleInitial mediaHidden');
      $('.product-media--video-loaded, .product-media--model-loaded', container).each(function(){
        $(this).data('player').destroy();
      });
      $('.product-media--video video', container).off('playing pause ended');
      $('model-viewer', container).off('shopify_model_viewer_ui_toggle_play shopify_model_viewer_ui_toggle_pause');
    }
  }

  theme.applyAjaxToProductForm = function($form) {
    var shopifyAjaxAddURL = theme.routes.cart_add_url + '.js';
    var shopifyAjaxStorePageURL = theme.routes.search_url;
    $form.filter('.product-form[data-ajax="true"]').on('submit', function(evt) {
      evt.preventDefault();

      var $form = $(this);
      //Disable add button
      $form.find('button[type="submit"]').attr('disabled', 'disabled').html(theme.strings.products_product_adding_to_cart);

      // Add to cart
      $.post(shopifyAjaxAddURL, $form.serialize(), function(data) {
        // Enable add button
        var $btn = $form.find('button[type="submit"]').removeAttr('disabled');

        // Show added message
        $btn.html(theme.icons.tick + ' ' + theme.strings.products_product_added_to_cart);

        // Back to default button text
        setTimeout(function(){
          $btn.html(theme.strings.products_product_add_to_cart);
        }, 1000);

        // Added, show CTA
        if($btn.next('.added-cta').length == 0) {
          var $cta = $('<a></a>').attr('href', theme.routes.cart_url);
          $cta.append($('<span class="beside-img">').html(theme.strings.products_product_added_cta));
          $cta.append(' ').append(theme.icons.chevronRight);
          $cta = $cta.wrap('<div class="added-cta">').parent().hide().insertAfter($btn.closest('.quantadd'));
          $cta.slideDown(500, function(){
            $(this).addClass('show');
            // resize lightbox, if in quick-buy
            if($btn.closest('#fancybox-content').length) {
              $.fancybox.resize();
            }
          });
        }

        // Update header
        $.get(shopifyAjaxStorePageURL, function(data){
          var $newCartObj = $(data).find('.page-header .cartsummary');
          var $currCart = $('.page-header .cartsummary');
          $currCart.html($newCartObj.html());
        });
      }, 'text').error(function(data) {
        // Enable add button
        $form.find('button[type="submit"]').removeAttr('disabled').html(theme.strings.products_product_add_to_cart);
        var currentInventory = parseInt($form.find('button[type="submit"]').attr('data-current-inventory'));

        // Not added, show message
        if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
          var jsonRes = $.parseJSON(data.responseText);
          var updatedResMsg = `This item has ${currentInventory} available and they have been added to your cart`;
          console.log('ATC jsonRes.description',updatedResMsg)
          theme.showQuickPopup(updatedResMsg, $form.find('button[type="submit"]:first'));
        } else {
          //Some unknown error? Disable ajax and add the old-fashioned way.
          $form.addClass('noAJAX');
          $form.submit();
        }
      });
    });
  }

  theme.removeAjaxFromProductForm = function($form){
    $form.off('submit');
  }

  // A section that contains other sections, e.g. story page
  theme.NestedSectionsSection = new function(){
    this.onSectionLoad = function(container){
      // load child sections
      $('[data-nested-section-type]', container).each(function(){
        var type = $(this).attr('data-nested-section-type');
        var section = null;
        for(var i=0; i<theme.Sections._sections.length; i++) {
          if(theme.Sections._sections[i].type == type) {
            section = theme.Sections._sections[i].section;
          }
        }
        if(section) {
          theme.Sections._instances.push({
            target: this,
            section: section
          });
          section.onSectionLoad(this);
        }
      });
    }

    this.onSectionUnload = function(container){
      // unload child sections
      $('[data-nested-section-type]', container).each(function(){
        theme.Sections.sectionUnload(this);
      });
    }

    this.onBlockSelect = function(container){
      // scroll to block
      $(window).scrollTop($(container).offset().top - 100);
    }
  }

  theme.CustomRowSection = new function(){
    this.onSectionLoad = function(container){
      theme.VideoManager.onSectionLoad(container);
    }

    this.onSectionUnload = function(container){
      theme.VideoManager.onSectionUnload(container);
    }
  }

  theme.FeaturedProduct = new function(){
    this.onSectionLoad = function(container){
      // gallery
      $('.product-gallery', container).trigger('initProductGallery');

      // product options
      theme.OptionManager.initProductOptions($('[name="id"]'));
    }

    this.onSectionUnload = function(container){
      $('.product-gallery', container).trigger('destroyProductGallery');
      theme.OptionManager.unloadProductOptions($('[name="id"]', container));
    }
  }

  theme.SlideshowSection = new function(){
    this.onSectionLoad = function(container){
      $('.slideshow', container).each(function(){
        $(this).on('init', function(){
          $('.lazyload--manual', this).removeClass('.lazyload--manual').addClass('lazyload');
        }).slick({
          autoplay: $(this).hasClass('auto-play'),
          fade: true,
          infinite: true,
          useTransform: true,
          prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                fade: false,
                arrows: false
              }
            }
          ],
          autoplaySpeed: parseInt($(this).data('slideshow-interval'))

        }).on('setPosition', function(e, slick){
          // ensure text overlay is fully visible
          var _this = this;
          setTimeout(function(){
            var isBumped = false;
            var tallestSlide = 0;
            $('.slick-slide', _this).each(function(){
              var $img = $(this).children('img:first');
              if($img.length == 0) { return; }
              var imgHeight = $img.height();
              tallestSlide = Math.max(tallestSlide, $img.height());
              $('.overlay-text', this).each(function(){
                var overlayVerticalInset = $(this).position().top;
                var overlayHeight = 2*overlayVerticalInset + $(this).children('.inner').height();
                if(overlayHeight > imgHeight) {
                  isBumped = true;
                }
                tallestSlide = Math.max(tallestSlide, overlayHeight);
              });
            });
            if(isBumped) {
              $('.slick-slide', _this).addClass('slide--using-background').each(function(){
                $(this).css({
                  minHeight: tallestSlide,
                  backgroundImage: "url('"+$(this).find('img').attr('src')+"')"
                });
              });
            } else {
              $('.slick-slide', _this).removeClass('slide--using-background').css({
                minHeight: '',
                backgroundImage: ''
              });
            }
          }, 11);
        });
      });

      theme.resizeScalingTextFromColumn();

      // Make slideshow page height
      $('.slideshow.type-full-page:not(.full-page-init)', container).addClass('full-page-init').each(function(){
        var $this = $(this);
        $(window).on('debouncedresize checkfullheightsliders', function(){
          $this.find('.slide').css('height', $(window).height() - $('.page-header').outerHeight());
        }).trigger('checkfullheightsliders');
      });
    }

    this.onSectionUnload = function(container){
      $('.slick-slider', container).off('setPosition init').slick('unslick');
    }

    this.onBlockSelect = function(container){
      $(container).closest('.slick-slider')
      .slick('slickGoTo', $(container).data('slick-index'))
      .slick('slickPause');
    }

    this.onBlockDeselect = function(container){
      $(container).closest('.slick-slider').slick('slickPlay');
    }
  }

  theme.ImageWithTextOverlay = new function(){
    var _ = this;
    _.checkTextOverImageHeights = function(){
      $('[data-section-type="image-with-text-overlay"], [data-nested-section-type="image-with-text-overlay"]').has('.overlay-text').each(function(){
        var $imageContainer = $('.rimage-outer-wrapper', this);
        var imageHeight = $('.rimage-wrapper', this).outerHeight();
        var textVerticalPadding = $('.overlay-text', this).position().top;
        var textHeight = $('.overlay-text > .inner', this).height() + textVerticalPadding * 2;
        if(textHeight > imageHeight + 2) { // +2 for rounding errors
          $imageContainer.css('height', textHeight);
        } else {
          $imageContainer.css('height', '');
        }
      });
    }

    this.onSectionLoad = function(container){
      theme.resizeScalingTextFromColumn();
      _.checkTextOverImageHeights();
      $(window).off('.imageWithTextOverlaySection');
      $(window).on('load.imageWithTextOverlaySection', _.checkTextOverImageHeights);
      $(window).on('resize.imageWithTextOverlaySection', _.checkTextOverImageHeights);
    }

    this.onSectionUnload = function(container){
      $(window).off('.imageWithTextOverlaySection');
    }
  }

  theme.MapSection = new function(){
    var _ = this;
    _.config = {
      zoom: 14,
      styles: {
        default: [],
        silver: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}],
        retro: [{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#c9b2a6"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#ae9e90"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}],
        dark: [{"elementType":"geometry","stylers":[{"color":"#212121"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#212121"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#757575"}]},{"featureType":"administrative.country","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#181818"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"poi.park","elementType":"labels.text.stroke","stylers":[{"color":"#1b1b1b"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#2c2c2c"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#8a8a8a"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#373737"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#3c3c3c"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#4e4e4e"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#3d3d3d"}]}],
        night: [{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}],
        aubergine: [{"elementType":"geometry","stylers":[{"color":"#1d2c4d"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#8ec3b9"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#1a3646"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#64779e"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#334e87"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#023e58"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#283d6a"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6f9ba5"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#023e58"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#3C7680"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#304a7d"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#2c6675"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#255763"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#b0d5ce"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#023e58"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#283d6a"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#3a4762"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#0e1626"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#4e6d70"}]}]
      }
    };
    _.apiStatus = null;
    _.mapsToLoad = [];

    this.geolocate = function($map) {
      var deferred = $.Deferred();
      var geocoder = new google.maps.Geocoder();
      var address = $map.data('address-setting');

      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          deferred.reject(status);
        }

        deferred.resolve(results);
      });

      return deferred;
    }

    this.createMap = function(container) {
      var $map = $('.map-section__map-container', container);

      return _.geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: _.config.zoom,
            styles: _.config.styles[_.style],
            center: results[0].geometry.location,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true,
            zoomControl: true
          };

          _.map = new google.maps.Map($map[0], mapOptions);
          _.center = _.map.getCenter();

          var marker = new google.maps.Marker({
            map: _.map,
            position: _.center,
            clickable: false
          });

          google.maps.event.addDomListener(window, 'resize', function() {
            google.maps.event.trigger(_.map, 'resize');
            _.map.setCenter(_.center);
          });
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = theme.strings.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = theme.strings.addressQueryLimit;
            break;
          default:
            errorMessage = theme.strings.addressError;
            break;
        }

        // Only show error in the theme editor
        if (Shopify.designMode) {
          var $mapContainer = $map.parents('.map-section');

          $mapContainer.addClass('page-width map-section--load-error');
          $mapContainer
          .find('.map-section__wrapper')
          .html(
            '<div class="errors text-center">' + errorMessage + '</div>'
          );
        }
      });
    }

    this.onSectionLoad = function(container){
      var $container = $(container);
      // Global function called by Google on auth errors
      window.gm_authFailure = function() {
        if (!Shopify.designMode) return;

        $container.addClass('page-width map-section--load-error');
        $container
        .find('.map-section__wrapper')
        .html(
          '<div class="errors text-center">' + theme.strings.authError + '</div>'
        );
      }

      // create maps
      var key = $container.data('api-key');
      _.style = $container.data('map-style');

      if (typeof key !== 'string' || key === '') {
        return;
      }

      if (_.apiStatus === 'loaded') {
        // Check if the script has previously been loaded with this key
        var $script = $('script[src*="' + key + '&"]');
        if ($script.length === 0) {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            _.apiStatus = 'loaded';
            _.createMap($container);
          });
        } else {
          _.createMap($container);
        }
      } else {
        _.mapsToLoad.push($container);

        if (_.apiStatus !== 'loading') {
          _.apiStatus = 'loading';
          if (typeof window.google === 'undefined') {
            $.getScript(
              'https://maps.googleapis.com/maps/api/js?key=' + key
            ).then(function() {
              _.apiStatus = 'loaded';
              // API has loaded, load all Map instances in queue
              $.each(_.mapsToLoad, function(index, mapContainer) {
                _.createMap(mapContainer);
              });
            });
          }
        }
      }
    }

    this.onSectionUnload = function(container){
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  }

  theme.HeaderSection = new function(){
    // set navbar 'top' value based on screen size and header position
    this.assessHeaderHeight = function(){
      var $header = $('.page-header'),
          navBarTop = '',
          contentTop = '';
      if($header.length && $header.css('position') == 'fixed') {
        var headerHeight = $header.outerHeight();
        contentTop = headerHeight;
        if($header.hasClass('page-header--full-width')) {
          navBarTop = headerHeight;
        }
      }

      $('#navbar').css('top', navBarTop);
      $('#content').css('padding-top', contentTop);
    }

    this.onSectionLoad = function(container){
      // Never allow the home page to be active
      $('.mainnav .tier1 .expanded > a').filter(function(){
        return $(this).attr('href').length < 6; // assume home page url will not be longer than "/fr/"
      }).parents('li.expanded').removeClass('expanded');

      // Only allow one expanded menu
      $('.mainnav .tier1 > ul > li.expanded:first').nextAll('.expanded').removeClass('expanded').find('.expanded').removeClass('expanded');

      // Expand sidebar nav on page load
      $('.mainnav .tier1 > ul > li.expanded:first > a').each(function(){
        var $tier1 = $(this).closest('.tier1');
        // only show if inside-mode
        if($('#navbar').hasClass('nav-style-in')) {
          $tier1.addClass('removetrans showback');
          $(this).click();
        }
        setTimeout(function(){
          $tier1.removeClass('removetrans');
        }, 10);
      });

      // ensure top edge of nav is correct
      this.assessHeaderHeight();
      $(window).on('load debouncedresize', this.assessHeaderHeight);

      
      // live/predictive search
      var $resultsBox = $('.quick-search__results', container);
      if(theme.Shopify.features.predictiveSearch && $resultsBox.length) {
        var searchTimeoutThrottle = 500;
        var searchTimeoutID = -1;
        var currReqObj = null;
        var $resultItemsBox = $('.quick-search__results-items', container);

        var pageResultTemplate = [
          '<div class="block text size-large">',
          '<div class="main">',
          '<%= image %>',
          '<h2 class="search-result-title"><%= title %></h2>',
          '<p class="search-result-description"><%= content %></p>',
          '</div>',
          '<div class="sub">',
          '<a class="cta-link" href="<%= url %>">', theme.strings.searchReadMore, '</a>',
          '</div>',
          '</div>'
        ].join('');
        var pageResultImageTemplate = '<p class="image"><a href="<%= url %>"><img src="<%= src %>" alt="" role="presentation"></a></p>';
        var productResultTemplate = [
          '<div class="block product size-medium">',
          '<div class="main">',
          '<a class="img-link" href="<%= url %>">',
          '<%= image %>',
          '</a>',
          
          '<div class="quick-buy-row">',
          '<a href="<%= url %>" class="quick-buy button button--slim">', theme.strings.productListingQuickView, '</a>',
          '</div>',
          
          '</div>',
          '<div class="sub">',
          (
            $resultsBox.data('show-vendor') ?
            [
              '<div class="product-vendor">',
              '<%= vendor %>',
              '</div>'
            ].join('') : ''
          ),
          '<a class="product-block-title" href="<%= url %>"><%= title %></a>',
          (
            $resultsBox.data('show-price') ?
            [
              '<div class="pricearea">',
              '<%= price %>',
              '</div>'
            ].join('') : ''
          ),
          '</div>',
          
          '</div>'
        ].join('');

        $(container).on('keyup change', '.quick-search__input', function(){
          //Only search if search string longer than 2, and it has changed
          if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
            //Reset previous value
            $(this).data('oldval', $(this).val());

            // Kill outstanding ajax request
            if(currReqObj != null) currReqObj.abort();

            // Kill previous search
            clearTimeout(searchTimeoutID);

            var $form = $(this).closest('form');

            //URL for full search page
            var linkURL = $form.attr('action') + '?' + $form.serialize();

            //Show loading
            $resultsBox.addClass('quick-search__results--loading');

            // Do next search (in X milliseconds)
            searchTimeoutID = setTimeout(function(){
              //Ajax hit on search page
              currReqObj = $.ajax({
                url: theme.routes.search_url + '/suggest.json',
                data: {
                  "q": $form.find('input[name="q"]').val(),
                  "resources": {
                    "type": $form.find('input[name="type"]').val(),
                    "limit": 10,
                    "options": {
                      "unavailable_products": 'last'
                    }
                  }
                },
                dataType: "json",
                success: function(response){
                  currReqObj = null;
                  $resultsBox.removeClass('quick-search__results--loading');
                  var $results = $('<div>');

                  if(response.resources.results.products) {
                    for(var i = 0; i < response.resources.results.products.length; i++) {
                      var result = response.resources.results.products[i];
                      var priceHtml = '';
                      var imageHtml = '';

                      if(result.image) {
                        imageHtml = [
                          '<div class="product-image">',
                          '<div class="product-image__primary rimage-wrapper rimage-wrapper--natural-size lazyload--placeholder">',
                          '<img class="rimage__image lazyload fade-in" data-src="',
                          theme.Shopify.formatImage(result.image, '350x'),
                          '" alt="" role="presention"/>',
                          '</div>',
                          '</div>'
                        ].join('');
                      }

                      if(result.price_max != result.price_min) {
                        priceHtml += '<span class="product-price__from">' + theme.strings.productsListingFrom + '</span> ';
                      }

                      if(result.compare_at_price_min > result.price_min) {
                        priceHtml += [
                          '<span class="product-price__amount product-price__amount--on-sale theme-money">',
                          theme.Shopify.formatMoney(result.price_min, theme.money_format),
                          '</span> ',
                          '<span class="product-price__compare theme-money">',
                          theme.Shopify.formatMoney(result.compare_at_price_min, theme.money_format),
                          '</span>'
                        ].join('');
                      } else {
                        priceHtml += '<span class="product-price__amount theme-money">' + theme.Shopify.formatMoney(result.price_min, theme.money_format) + '</span>';
                      }

                      $results.append(
                        productResultTemplate.replace('<%= image %>', imageHtml)
                        .replace('<%= title %>', result.title)
                        .replace('<%= vendor %>', result.vendor)
                        .replace('<%= price %>', priceHtml)
                        .replace(/<%= url %>/g, result.url)
                        .replace('<%= id %>', result.id)
                      );
                    }
                  }

                  if(response.resources.results.pages) {
                    for(var i = 0; i < response.resources.results.pages.length; i++) {
                      var result = response.resources.results.pages[i];
                      $results.append(
                        pageResultTemplate.replace('<%= image %>', '')
                        .replace('<%= title %>', result.title)
                        .replace('<%= content %>', 'CONTENT')
                        .replace('<%= url %>', result.url)
                      );
                    }
                  }

                  if(response.resources.results.articles) {
                    for(var i = 0; i < response.resources.results.articles.length; i++) {
                      var result = response.resources.results.articles[i];
                      var image;
                      if(result.image) {
                        image = pageResultImageTemplate
                        .replace('<%= src %>', theme.Shopify.formatImage(result.image, '400x'))
                        .replace('<%= url %>', result.url);
                      } else {
                        image = '';
                      }

                      $results.append(
                        pageResultTemplate.replace('<%= image %>', image)
                        .replace('<%= title %>', result.title)
                        .replace('<%= content %>', 'CONTENT')
                        .replace('<%= url %>', result.url)
                      );
                    }
                  }

                  if($results.children().length == 0) {
                    // No results
                    $resultsBox.removeClass('quick-search__results--populated').addClass('quick-search__results--empty');
                    $resultItemsBox.empty();
                  } else {
                    // Numerous results
                    $resultsBox.removeClass('quick-search__results--empty').addClass('quick-search__results--populated');
                    $results.find('.block').append([
                      '<a href="', linkURL, '" class="quick-search__show-all cta-link-hover-parent">',
                      '<span class="quick-search__show-all-text">',
                      '<span class="quick-search__show-all-text cta-link">',
                      theme.strings.liveSearchSeeAll,
                      '</span>',
                      '</span>',
                      '</a>'].join(''));
                    $resultItemsBox.empty().append($results);
                      if (
                        window.Samita &&
                        Samita.LockAccess &&
                        typeof Samita.LockAccess.lockForSearchVer2 === "function"
                      ) {
                        Samita.LockAccess.lockForSearchVer2(
                          ".quick-search__results-items .block.product",
                          ".pricearea"
                        );
                      }
                    // reviews
                    if($results.find('.themed-product-reviews:first').length && window.SPR && SPR.initDomEls && SPR.loadBadges) {
                      SPR.initDomEls();
                      SPR.loadBadges();
                    }
                  }
                }
              });
            }, searchTimeoutThrottle);
          } else if ($(this).val().length <= 2) {
            //Deleted text? Clear results
            $resultsBox.removeClass('quick-search__results--loading quick-search__results--populated');
            $resultItemsBox.empty();
          }
        });
      }
      

      $(container).on('click', '.search, .quick-search__close, .quick-search-close-mask', function(){
        clearTimeout(theme.liveSearchHeaderClassTimeoutId);
        if($('body').toggleClass('show-quick-search').hasClass('show-quick-search')) {
          $(this).closest('.page-header').find('.quick-search').find('input:first').focus();
          $('body').addClass('page-header-above-mask');
        } else {
          theme.liveSearchHeaderClassTimeoutId = setTimeout(function(){
            $('body').removeClass('page-header-above-mask');
          }, 500);
        }
        return false;
      });

      // Touch events for fly-out nav
      if($('.nav-style-out', container).length) {
        var $body = $('body');
        $(container).on('touchstart touchend click', '.tier1title[aria-haspopup="true"]', function(evt){
          if(!$body.hasClass('show-nav-mobile')) {
            if(evt.type == 'touchstart') {
              $(this).data('touchstartedAt', evt.timeStamp);
            } else if(evt.type == 'touchend') {
              // down & up in under a second - presume tap
              if(evt.timeStamp - $(this).data('touchstartedAt') < 1000) {
                $(this).data('touchOpenTriggeredAt', evt.timeStamp);
                if($(this).parent().hasClass('outside-expanded')) {
                  // trigger close
                  $(this).parent().trigger('mouseleave');
                } else {
                  // trigger close on any open items
                  $('.outside-expanded').trigger('mouseleave');
                  // trigger open
                  $(this).parent().trigger('mouseenter');
                }
                // prevent fake click
                return false;
              }
            } else if(evt.type == 'click') {
              // if touch open was triggered very recently, prevent click event
              if($(this).data('touchOpenTriggeredAt') && evt.timeStamp - $(this).data('touchOpenTriggeredAt') < 1000) {
                return false;
              }
            }
          }
        });
      }

      $('.disclosure', container).each(function(){
        $(this).data('disclosure', new theme.Disclosure($(this)));
      });
    }

    this.onSectionUnload = function(container){
      $(container).off('click keyup change submit touchstart touchend');
      $(window).off('load debouncedresize', this.assessHeaderHeight);
      $('.disclosure', container).each(function(){
        $(this).data('disclosure').unload();
      });
    }
  }

  theme.FooterSection = new function(){
    this.onSectionLoad = function(container){
      if($('.nav-column__title', container).length) {
        $(container).on('click', '.nav-column__title .button', function(){
          $(this).closest('.page-footer__column').toggleClass('open');
        });
      }

      $('.disclosure', container).each(function(){
        $(this).data('disclosure', new theme.Disclosure($(this)));
      });
    }

    this.onSectionUnload = function(container){
      $(container).off('click');
      $('.disclosure', container).each(function(){
        $(this).data('disclosure').unload();
      });
    }
  }

  theme.ProductTemplateSection = new function(){
    this.onSectionLoad = function(container){
      // reviews link
      $('.themed-product-reviews', container).on('click', '.spr-badge', function(){
        $('html, body').animate({ scrollTop: $('#shopify-product-reviews').offset().top - 50 }, 1000);
      });

      // gallery
      $('.product-gallery', container).trigger('initProductGallery');

      // product options
      theme.OptionManager.initProductOptions($('[name="id"]'));

      // size chart link
      $('.size-chart-link', container).on('click', function(){
        $.fancybox({
          content: $(this).closest('.size-chart-container').find('.size-chart-content').html()
        });
        return false;
      });

      // related products layout
      $(document).trigger('loadmasonry');
    }

    this.onSectionUnload = function(container){
      $('.product-gallery', container).trigger('destroyProductGallery');
      theme.OptionManager.unloadProductOptions($('[name="id"]', container));
      $('.blocklayout', container).masonry('destroy');
      $('.size-chart-link', container).off('click');
      $('.themed-product-reviews', container).off('click');
    }
  }

  theme.FeaturedCollectionSection = new function(){
    this.onSectionLoad = function(container){
      $(document).trigger('loadmasonry');
    }

    this.onSectionUnload = function(container){
      $('.blocklayout', container).masonry('destroy');
    }
  }

  theme.FeaturedCollectionsSection = new function(){
    this.onSectionLoad = function(container){
      $(document).trigger('loadmasonry');
    }

    this.onSectionUnload = function(container){
      $('.blocklayout', container).masonry('destroy');
    }
  }

  theme.CollectionTemplateSection = new function(){
    this.onSectionLoad = function(container){
      // Sorting
      var $sortBy = $('#sort-by', container);
      if($sortBy.length > 0) {
        var queryParams = {};
        if (location.search.length) {
          for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
        $sortBy.val($sortBy.data('initval')).trigger('change').on('change', function() {
          queryParams.sort_by = $(this).val();
          location.search = $.param(queryParams).replace(/\+/g, '%20');
        });
      }

      // Filter group URLs - dropdowns are for switching between tags
      var $filterConts = $('.filter--dropdown select', container);
      if($filterConts.length) {
        $filterConts.each(function(){
          var activeTag = $(this).find('option[selected]').data('custom');
          $(this).find('option').each(function(){
            var spl = $(this).val().split('/');
            var tags = spl[spl.length-1].split('+');
            var index = tags.indexOf(activeTag);
            if (index > -1) {
              tags.splice(index, 1);
            }
            spl.splice(spl.length-1, 1);
            var value = spl.join('/') + '/' + tags.join('+');
            $(this).attr('value', value);
          });
        });
      }

      // Masonry layout
      $(document).trigger('loadmasonry');


      // Infinite scroll (requires max one on page)
      if($('.pagination:not(.init-infiniscroll)', container).length == 1
         && $('.pagination:not(.init-infiniscroll) a.next', container).length > 0
         && $('.blocklayout1.do-infinite', container).length == 1) {
        var $pager = $('.pagination', container).addClass('init-infiniscroll');
        var $moreBtn = $('<a href="'+$pager.find('a.next').attr('href')+'" class="infiniscroll" />').html(theme.strings.products_listing_more_products);
        $pager.empty().append($moreBtn);

        // Click to show more
        $pager.on('click', 'a.infiniscroll:not(.loading)', function(){
          $moreBtn.addClass('loading').html(theme.strings.products_listing_loading);
          $.get($pager.find('a').attr('href'), function(data){
            var $data = $($.parseHTML(data));
            // isolate and hide new blocks
            var $newbies = $data.find('.blocklayout1 .block:not(.no-inf)');
            $newbies.addClass('initially-hidden');
            // Add to masonry, & reveal
            theme.MasonryManager.appendItems($newbies, $('.blocklayout1'));
            $newbies.removeClass('initially-hidden');

            // Any more?
            var $next = $data.find('.pagination a.next');
            if($next.length == 0) {
              //We are out of products
              $pager.html('<span class="infiniscroll no-more">' + theme.strings.products_listing_no_more_products + '</span>').fadeOut(5000);
            } else {
              //More to show
              $moreBtn.attr('href', $next.attr('href')).removeClass('loading').html(theme.strings.products_listing_more_products);
            }



            setTimeout(function(){
              $('body').each(function(){  
                var highestBox = 0;
                $('.product-block-title', this).each(function(){
                  if($(this).height() > highestBox) {
                    highestBox = $(this).height(); 
                  }
                });  
                $('.product-block-title',this).height(highestBox);               
                
                
                var highestBox1 = 0;
                $('.productoptions .option-selectors', this).each(function(){
                  if($(this).height() > highestBox1) {
                    highestBox1 = $(this).height(); 
                  }
                });  
                $('.productoptions .option-selectors',this).height(highestBox1);
                $(window).resize();
              }); 
            },30); 
          });
          return false;
        });

        // Scroll event to trigger click
        $(window).on('scroll.infiniscroll', function(){
          var $pager = $('.pagination.init-infiniscroll');
          if($pager.length && $(window).scrollTop() + $(window).height() > $pager.offset().top) {
            $pager.find('a').trigger('click');
          }
        });
      }
    }

    this.onSectionUnload = function(container){
      $('#sort-by', container).off('change');
      $('.blocklayout', container).masonry('destroy');
      $(window).off('scroll.infiniscroll')
    }
  }

  theme.ListCollectionsTemplateSection = new function(){
    this.onSectionLoad = function(container){
      // Masonry layout
      $(document).trigger('loadmasonry');
    }

    this.onSectionUnload = function(container){
      $('.blocklayout', container).masonry('destroy');
    }
  }

  theme.BlogTemplateSection = new function(){
    this.onSectionLoad = function(container){
      $(document).trigger('loadmasonry');
    }

    this.onSectionUnload = function(container){
      $('.blocklayout', container).masonry('destroy');
    }
  }

  // Manage option dropdowns
  theme.productData = {};
  theme.OptionManager = new function(){
    var _ = this;

    _._getVariantOptionElement = function(variant, $container) {
      return $container.find('select[name="id"] option[value="' + variant.id + '"]');
    };

    _.selectors = {
      container: '.product-container',
      gallery: '.product-gallery',
      priceArea: '.pricearea',
      unitPriceArea: '.unit-price',
      submitButton: 'input[type=submit], button[type=submit]',
      multiOption: '.option-selectors'
    };

    _.strings = {
      priceNonExistent: theme.strings.products_variant_non_existent,
      unitPriceSeparator: theme.strings.products_variant_unit_price_separator,
      buttonDefault: theme.strings.products_product_add_to_cart,
      buttonNoStock: theme.strings.products_variant_out_of_stock,
      buttonNoVariant: theme.strings.products_variant_non_existent
    };

    _._getString = function(key, variant){
      var string = _.strings[key];
      if(variant) {
        string = string.replace('[PRICE]', '<span class="theme-money">'+theme.Shopify.formatMoney(variant.price, theme.money_format)+'</span>');
      }
      return string;
    }

    _.getProductData = function($form) {
      var productId = $form.data('product-id');
      var data = null;
      if(!theme.productData[productId]) {
        theme.productData[productId] = JSON.parse(document.getElementById('ProductJson-' + productId).innerHTML);
      }
      data = theme.productData[productId];
      if(!data) {
        console.log('Product data missing (id: '+$form.data('product-id')+')');
      }
      return data;
    }

    _.addVariantUrlToHistory = function(variant) {
      if(variant) {
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      }
    }

    _.updateSku = function(variant, $container){
      $container.find('.sku .sku__value').html( variant ? variant.sku : '' );
      $container.find('.sku').toggleClass('sku--no-sku', !variant || !variant.sku);
    }

    _.updateBarcode = function(variant, $container){
      $container.find('.barcode .barcode__value').html( variant ? variant.barcode : '' );
      $container.find('.barcode').toggleClass('barcode--no-barcode', !variant || !variant.barcode);
    }

    _.updateBackorder = function(variant, $container){
      var $backorder = $container.find('.backorder');
      if($backorder.length) {
        if (variant && variant.available) {
          if (variant.inventory_management && _._getVariantOptionElement(variant, $container).data('stock') == 'out') {
            var productData = _.getProductData($backorder.closest('form'));
            $backorder.find('.selected-variant').html(productData.title + (variant.title.indexOf('Default') >= 0 ? '' : ' - '+variant.title) );
            $backorder.show();
          } else {
            $backorder.hide();
          }
        } else {
          $backorder.hide();
        }
      }
    }

    _.updatePrice = function(variant, $container) {
      var $priceArea = $container.find(_.selectors.priceArea),
          $existingUnitPriceArea = $container.find(_.selectors.unitPriceArea);

      if(variant) {
        var $newPriceArea = $('<div>');
        var $currentPrice = $('<span class="price theme-money">').html(theme.Shopify.formatMoney(variant.price, theme.money_format)).appendTo($newPriceArea);
        if(variant.compare_at_price > variant.price) {
          $newPriceArea.append(' ');
          $('<span class="was-price theme-money">').html(theme.Shopify.formatMoney(variant.compare_at_price, theme.money_format)).appendTo($newPriceArea);
          $currentPrice.addClass('price--reduced');
        }
        $priceArea.html($newPriceArea.html());

        if(variant.unit_price_measurement){
          var $newUnitPriceArea = $('<div class="unit-price">');
          $('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(variant.unit_price, theme.money_format)).appendTo($newUnitPriceArea);
          $('<span class="unit-price__separator">').html(_._getString('unitPriceSeparator')).appendTo($newUnitPriceArea);
          $('<span class="unit-price__unit">').html(_.getBaseUnit(variant)).appendTo($newUnitPriceArea);

          if($existingUnitPriceArea.length) {
            $existingUnitPriceArea.replaceWith($newUnitPriceArea);
          } else {
            $priceArea.after($newUnitPriceArea);
          }
        } else {
          $existingUnitPriceArea.remove();
        }
      } else {
        $priceArea.html(_._getString('priceNonExistent', variant));
        $existingUnitPriceArea.remove();
      }
    }

    _.getBaseUnit = function(variant) {
      return variant.unit_price_measurement.reference_value === 1
      ? variant.unit_price_measurement.reference_unit
      : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    },

      _._updateButtonText = function($button, string, variant) {
      $button.each(function(){
        var newVal;
        newVal = _._getString('button' + string, variant);
        if(newVal !== false) {
          if($(this).is('input')) {
            $(this).val(newVal);
          } else {
            $(this).html(newVal);
          }
        }
      });
    }

    _.updateButtons = function(variant, $container, productData) {
      var $button = $container.find(_.selectors.submitButton);
      var variantsData = JSON.parse(document.getElementById('ProductVariantsJson-' + productData.id).innerHTML);
      if(variantsData.length>0){
        var varInventory = variantsData.filter((v)=>{return v.id == variant.id});
        // console.log('varInventory',varInventory)
        if(varInventory.length>0){
          $button.attr('data-current-inventory', varInventory[0].inventory_quantity);
        }
      }

      if(variant && variant.available == true) {
        $button.removeAttr('disabled');
        _._updateButtonText($button, 'Default', variant);
      } else {
        $button.attr('disabled', 'disabled');
        if(variant) {
          _._updateButtonText($button, 'NoStock', variant);
        } else {
          _._updateButtonText($button, 'NoVariant', variant);
        }
      }
    }

    _.updateContainerStatusClasses = function(variant, $container) {
      $container.toggleClass('variant-status--unavailable', !variant.available);
      $container.toggleClass('variant-status--backorder', variant.available
                             && variant.inventory_management
                             && _._getVariantOptionElement(variant, $container).data('stock') == 'out');
    }

    _.initProductOptions = function(originalInput) {
      $(originalInput).not('.theme-init').addClass('theme-init').each(function(){
        var $originalInput = $(this);
        if($originalInput.is('select')) {
          var productData = _.getProductData($originalInput.closest('form'));

          // change state for original dropdown
          $originalInput.on('change.themeProductOptions firstrun.themeProductOptions', function(e, variant){
            if($(this).is('input[type=radio]:not(:checked)')) {
              return; // handle radios - only update for checked
            }
            var variant = variant;
            if(!variant && variant !== false) {
              for(var i=0; i<productData.variants.length; i++) {
                if(productData.variants[i].id == $(this).val()) {
                  variant = productData.variants[i];
                }
              }
            }
            var $container = $(this).closest(_.selectors.container);

            // update price
            _.updatePrice(variant, $container);

            // update buttons
            _.updateButtons(variant, $container,productData);

            // variant images
            if (variant && variant.featured_media) {
              $container.find(_.selectors.gallery).trigger('variantImageSelected', variant);
            }

            // extra details
            _.updateBarcode(variant, $container);
            _.updateSku(variant, $container);
            _.updateBackorder(variant, $container);
            _.updateContainerStatusClasses(variant, $container);

            // variant urls
            var $form = $(this).closest('form');
            if($form.data('enable-history-state') && e.type == 'change') {
              _.addVariantUrlToHistory(variant);
            }
          });

          // split-options wrapper
          $originalInput.closest(_.selectors.container).find(_.selectors.multiOption).on('change.themeProductOptions', 'select', function(){
            var selectedOptions = [];
            $(this).closest(_.selectors.multiOption).find('select').each(function(){
              selectedOptions.push($(this).val());
            });
            // find variant
            var variant = false;
            for(var i=0; i<productData.variants.length; i++) {
              var v = productData.variants[i];
              var matchCount = 0;
              for(var j=0; j<selectedOptions.length; j++) {
                if(v.options[j] == selectedOptions[j]) {
                  matchCount++;
                }
              }
              if(matchCount == selectedOptions.length) {
                variant = v;
                break;
              }
            }
            // trigger change
            if(variant) {
              $originalInput.val(variant.id);
            }
            $originalInput.trigger('change', variant);
          });

          // first-run
          $originalInput.trigger('firstrun');
        }

        // ajax
        theme.applyAjaxToProductForm($originalInput.closest('form'));
      });
    }

    _.unloadProductOptions = function(originalInput) {
      $(originalInput).removeClass('theme-init').each(function(){
        $(this).off('.themeProductOptions');
        $(this).closest(_.selectors.container).find(_.selectors.multiOption).off('.themeProductOptions');
        theme.removeAjaxFromProductForm($(this).closest('form'));
      });
    }
  };

  /// Footer position
  theme.repositionFooter = function(){
    var $preFooterContent = $('#content');
    var $footer = $('.page-footer');
    var offset = $(window).height() - ($preFooterContent.offset().top + $preFooterContent.outerHeight()) - $footer.outerHeight();
    $footer.css('margin-top', offset > 0 ? offset : '');
  };

  /// Text that scales based on column width
  theme.resizeScalingTextFromColumn = function() {
    $('.scaled-text').each(function(){
      var $base = $(this).closest('.scaled-text-base');
      var scale = $base.width() / 1200;
      $(this).css('font-size', (scale * 100) + '%');
    });
  }

  //Function to show a quick generic text popup above an element
  theme.showQuickPopup = function(message, $origin){
    var $popup = $('<div>').addClass('simple-popup hidden');
    var offs = $origin.offset();
    $('body').append($popup);
    $popup.html(message).css({ 'left':offs.left - ($popup.outerWidth() - $origin.outerWidth()), 'top':offs.top });
    $popup.css('margin-top', - $popup.outerHeight() - 10).removeClass('hidden');
    setTimeout(function(){
      $popup.addClass('hidden');
      setTimeout(function(){
        $popup.remove();
      }, 500);
    }, 4000);
  }

  theme.MasonryManager = new function(){
    var _ = this;
    _.getInitialisedMasonry = function() {
      return $('.blocklayout').filter(function(){
        return !!$(this).data('masonry');
      });
    }

    _.remasonry = function(){
      var w = _.setBlockWidths();
      var $masonries = _.getInitialisedMasonry();

      // limit to number of visible rows
      var perRow = Math.round($masonries.first().width() / w);
      $masonries.filter('[data-row-limit]:not([data-row-limit=""])').each(function(){
        var limit = $(this).data('row-limit') * perRow;
        $(this).children().each(function(index){
          $(this).toggleClass('hidden', index >= limit);
        });
      });

      _.setFixedSizes();

      $masonries.masonry({
        columnWidth: w
      });
    }

    _.setFixedSizes = function(){
      _.getInitialisedMasonry().each(function(){
        var $fixed = $(this).children('.fixed-ratio:not(.hidden):not(.size-large)');
        if($fixed.length > 0) {
          var h = -1;
          $fixed.each(function(i){
            var $lastChild = $(this).children().last();
            h = Math.max(h, $lastChild.position().top + $lastChild.outerHeight(true));
          });
          $fixed.css('height', h);
        }
      });
    }
    _.getUnInitialisedMasonry = function() {
      return $('.blocklayout').filter(function(){
        return !$(this).data('masonry');
      });
    }

    _.getBlockMargin = function($masonry) {
      var $firstBlock = $masonry.find('.block:first');
      return $firstBlock.length ? parseInt($firstBlock.css('margin-left')) : 15;
    }

    _.columnWidth = function($masonry) {
      var baseWidth = 150;
      if(typeof $masonry.data('block-width') !== 'undefined') {
        baseWidth = parseInt($masonry.data('block-width'));
      }
      var defWidth = baseWidth * ($masonry.hasClass('double-sized')?2:1) + _.getBlockMargin($masonry) * 2;
      var cols = Math.ceil(($masonry.width() - 200) / defWidth);

      //Min two per row on mobile (delete to go 1-a-row)
      var isProductGrid = $masonry.find('.block:not(.product)').length == 0;
      if(isProductGrid && $(window).width() < 768) {
        cols = Math.max(2, cols);
      }

      return Math.floor($masonry.width() / cols);
    }

    _.setBlockWidths = function() {
      var colWidth = 0;
      $('.blocklayout').each(function(){
        var $masonry = $(this);
        colWidth = _.columnWidth($masonry);
        console.log('colWidth',colWidth);
        var marginWidth = _.getBlockMargin($masonry) * 2;
        $masonry.children(':not(.size-large)').css('width', colWidth - marginWidth);
        if($(window).width() < colWidth*2 + marginWidth*2) {
          $masonry.children('.size-large').css('width', colWidth - marginWidth);
        } else {
          $masonry.children('.size-large').css('width', colWidth * 2 - marginWidth);
        }
      });
      return colWidth;
    }

    _.appendItems = function($items, $masonryContainer) {
      $masonryContainer.append($items);
      _.setBlockWidths();
      _.setFixedSizes();
      $masonryContainer.masonry('appended', $items);
    }
  }

  theme.productGallerySlideshowTabFix = function($swiper) {
    var swiper = $swiper.data('swiper');
    if(swiper) {
      // which slide are we going to?
      var $activeMedia = $swiper.find('.product-media-gallery-selected').removeClass('product-media-gallery-selected'),
          $activeSlide = null;
      if($activeMedia.length) {
        // selected from thumbnail
        $activeSlide = $activeMedia.closest('.swiper-slide');
      } else {
        // visible
        $activeSlide = swiper.slides.filter(function(){
          if($(this).hasClass('swiper-slide-active')) {
            return true;
          } else {
            var containerLeft = swiper.container.offset().left,
                containerRight = containerLeft + swiper.container.width() + 15, // a bit extra to cover margins & stuff
                slideRight = Math.floor($(this).offset().left + $(this).width()); // avoid rounding errors
            return slideRight >= containerLeft && slideRight <= containerRight;
          }
          return false;
        });
      }

      // tabindex everything to prevent tabbing into hidden slides
      $activeSlide.find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function(){
        $(this).attr('tabindex', '0');
      });
      swiper.slides.not($activeSlide).find('a, input, button, select, iframe, video, model-viewer, [tabindex]').each(function(){
        $(this).attr('tabindex', '-1');
      });
    }
  }

  $(function($){
    $(document).on('variantImageSelected', '.product-gallery', function(e, variant){
      var $swiperImgLinks = $('.swiper-container:first .swiper-slide .product-gallery__image', this);
      var swiper = $('.swiper-container:first', this).data('swiper');
      if(swiper) {
        var toMatch = variant.featured_media.id;
        var $match = $swiperImgLinks.filter(function(){
          return $(this).data('media-id') == toMatch;
        }).first();

        if($match.length) {
          swiper.slideTo($match.parent().index());
        }
      }
    });

    //First masonry load
    $(document).on('loadmasonry', function(){
      theme.MasonryManager.getUnInitialisedMasonry().each(function(){
        var $masonry = $(this);
        $masonry.masonry({
          isResizeBound: false,
          itemSelector : '.block',
          columnWidth: theme.MasonryManager.setBlockWidths(),
          isLayoutInstant: true, //Built-in transforms are buggy, using CSS instead
          isAnimated: !Modernizr.csstransitions
        });

        setTimeout(function(){
          theme.MasonryManager.remasonry();
          // pagination hidden until products loaded, on collections
          $('.hidden-pagination').removeClass('hidden');
          // layout has changed
          theme.repositionFooter();
        }, 10);
      });
    }).trigger('loadmasonry');

    //Re-up the masonry after fonts are loaded, or on resize
    $(window).on('load debouncedresize', theme.MasonryManager.remasonry);

    /// Redirect dropdowns
    $(document).on('change', 'select.navdrop', function(){
      window.location = $(this).val();
    });

    /// General purpose lightbox
    $('a[rel="fancybox"]').fancybox({ titleShow: false });

    /// Main nav

    // Inside mode: Click top level item
    $(document).on('click', '.nav-style-in .mainnav .tier1 > ul > li > a, .show-nav-mobile .mainnav .tier1 > ul > li > a', function(e){
      if($(this).siblings('div').length) {
        e.preventDefault();
        var $this = $(this);
        // store scroll position
        var panelScroll = $('#navpanel').scrollTop();
        $('#navpanel').data('lastScroll', panelScroll);
        // scroll to top
        $('#navpanel').animate({ scrollTop: 0 }, panelScroll > 0 ? 250 : 0, function(){
          // transition
          $this.parent().addClass('expanded');
          var $tier1 = $this.closest('.tier1').addClass('inside-expanded-tier2');
          // a11y
          $this.attr('aria-expanded', 'true');
          $this.siblings('.tier2').attr('id', 'current-submenu');
          $('.mainnav .back').removeAttr('tabindex');
          // show back button
          setTimeout(function(){
            $tier1.addClass('showback');
          }, 250);
        });
      }
    });

    // Inside mode: Go back up
    $(document).on('click', '#navpanel .mainnav .back', function(e){
      e.preventDefault();
      // hide back button
      var $tier1 = $(this).closest('.tier1').removeClass('showback');

      // a11y
      $tier1.find('[aria-expanded]').attr('aria-expanded', 'false');
      $('.mainnav .back').attr('tabindex', '-1');
      $('#current-submenu').removeAttr('id');

      // scroll
      var lastScroll = $('#navpanel').data('lastScroll');
      var panelScroll = $('#navpanel').scrollTop();
      if(typeof lastScroll != 'undefined') {
        $('#navpanel').animate({ scrollTop: lastScroll + 'px' }, lastScroll != panelScroll ? 250 : 0);
      }

      // transition
      setTimeout(function(){
        $tier1.removeClass('inside-expanded-tier2');
        // after transition
        setTimeout(function(){
          $tier1.find('.expanded').removeClass('expanded');
        }, 260);
      }, 210);
    });


    // Flyout mode: Hover over nav
    var navHoverRemoveTimeoutId = -1;
    $(document).on('mouseenter mouseleave focusin focusout', 'body:not(.show-nav-mobile) .nav-style-out #navpanel .mainnav .tier1 > ul > li', function(e){
      if($(this).children('div').length) {
        e.preventDefault();
        var doShow = e.type == 'mouseenter' || e.type =='focusin';
        var w = $('#content').width();
        var $thisLi = $(this);
        clearTimeout(navHoverRemoveTimeoutId);
        if(doShow) {
          // clear existing visible items
          var $existing = $('.mainnav .outside-expanded').removeClass('outside-expanded');

          // prepare to show
          if(!$('body').hasClass('nav-outside-expanded-mode')) {
            $('body').addClass('nav-outside-expanded-mode');
            $('.bodywrap, .page-header').css('margin-right', $('#content').width() - w); // cater for scrollbar
          }
          $thisLi.find('.tier2 .tier-title').css('margin-top', $('#navpanel .shoplogo').outerHeight());

          // show (after reflow caused by css changes)
          $('body').addClass('nav-outside-expanded-show');
          $thisLi.addClass('outside-expanded');
          $thisLi.children('a').attr('aria-expanded', 'true');

        } else {
          // hide, after small delay
          $thisLi.children('a').attr('aria-expanded', 'false');
          navHoverRemoveTimeoutId = setTimeout(function(){
            $('body').removeClass('nav-outside-expanded-show');
            $thisLi.removeClass('outside-expanded');

            navHoverRemoveTimeoutId = setTimeout(function(){
              // remove hover mode & scrollbar margin
              $('body').removeClass('nav-outside-expanded-mode');
              $('.mainnav .tier2 .tier-title').css('margin-top', '');
              $('.bodywrap, .page-header').css('margin-right', '');
            }, 260); //post trans
          }, 500);
        }
      }
    });

    // Tier 3 expansion
    $(document).on('click', '.tier2 > ul > li > a', function(e){
      var $sib = $(this).siblings('ul');
      if($sib.length) {
        e.preventDefault();
        if($sib.is(':visible')) {
          $sib.slideUp(250);
          $(this).attr('aria-expanded', 'false').parent().removeClass('expanded');
        } else {
          $sib.slideDown(250);
          $(this).attr('aria-expanded', 'true').parent().addClass('expanded');
        }
      }
    });

    // Mobile nav visibility
    $(document).on('click', '.nav-toggle', function(e){
      e.preventDefault();
      $('body').toggleClass('show-nav-mobile');
    });
    $(document).on('click touchend', 'body.show-nav-mobile', function(e){
      if(e.target == this) {
        $(this).removeClass('show-nav-mobile');
        return false;
      }
    });


    /// Quick buy popup
    $(document).on('click', '.block.product .quick-buy', function(){
      var productSelector = '.product:not(.insert)';
      var $prod = $(this).closest(productSelector);
      var prevIndex = $prod.index(productSelector) - 1;
      var nextIndex = $prod.index(productSelector) + 1;
      if(nextIndex > $prod.siblings(productSelector).length) {
        nextIndex = -1;
      }

      $.fancybox.showActivity();

      var url = $(this).attr('href');
      url += url.indexOf('?') > -1 ? '&view=lightbox' : '?view=lightbox';

      $.get(url, function(data){
        var $template = $('<div class="quickbuy-form">').append(data);
        // update labels & ids
        $template.find('label[for]').each(function(){
          $(this).attr('for', $(this).attr('for') + '-qb');
        });
        $template.find('form[id], :input[id]').each(function(){
          $(this).attr('id', $(this).attr('id') + '-qb');
        });
        $.fancybox({
          padding: 0,
          showCloseButton: false,
          content: $($template.wrap('<div>').parent().html()).prepend(
            ['<div class="action-icons">',
             '<a href="#" class="prev-item action-icon" data-idx="',prevIndex,'" aria-label="', theme.strings.previous, '">', theme.icons.left, '</a>',
             '<a href="#" class="next-item action-icon" data-idx="',nextIndex,'" aria-label="', theme.strings.next, '">', theme.icons.right, '</a>',
             '<a href="#" class="close-box action-icon" aria-label="', theme.strings.close, '">', theme.icons.close, '</a>',
             '</div>'].join('')
          ),
          onComplete: function(){
            // init product form, if required
            theme.OptionManager.initProductOptions($('.quickbuy-form [name=id]'));

            if(Shopify.PaymentButton && $('.quickbuy-form .shopify-payment-button').length) {
              $(document).on('shopify:payment_button:loaded.themeQuickBuy', function(){
                $(document).off('shopify:payment_button:loaded.themeQuickBuy');
                $.fancybox.resize();
              });

              Shopify.PaymentButton.init();
            }

            // gallery
            $('.quickbuy-form .product-gallery').trigger('initProductGallery');

            // set focus
            $('.quickbuy-form .close-box:first').focus();
          },
          onCleanup: function(){
            $('.quickbuy-form .product-gallery').trigger('destroyProductGallery');
            theme.OptionManager.unloadProductOptions($('.quickbuy-form [name=id]'));
          }
        });
      });

      return false;
    });
    $(document).on('click', '.quickbuy-form .close-box', function(){
      $.fancybox.close();
      return false;
    }).on('click', '.quickbuy-form .prev-item, .quickbuy-form .next-item', function(){
      $($('.block.product:not(.insert)').get($(this).data('idx'))).find('.quick-buy').click();
      return false;
    });

    // lightbox on click
    $(document).on('click', '.product-gallery .gallery-top button.product-gallery__image', function(e){
      e.preventDefault();
      if($(this).closest('.quickbuy-form').length == 0) {
        var $gall = $(this).closest('.product-gallery');
        if($('.gallery-top .swiper-slide', $gall).length > 1) {
          var imgs = Array();
          var srcToShow = $(this).data('zoom-src');
          var indexToShow = 0;
          $('.gallery-top .swiper-slide button.product-gallery__image', $gall).each(function(index){
            imgs.push({
              href: $(this).data('zoom-src')
            });
            if($(this).data('zoom-src') == srcToShow) {
              indexToShow = index;
            }
          });
          $.fancybox(imgs, { index: indexToShow, padding: 0 });
        } else {
          $.fancybox([{href: $(this).data('zoom-src')}], { padding: 0 });
        }
      }
    });


    $(window).on('load debouncedresize', theme.resizeScalingTextFromColumn);

    /// Terms requirement on cart
    $(document).on('click', '#cartform[data-require-terms="true"] #update-cart, #cartform[data-require-terms="true"] .additional-checkout-buttons a, #cartform[data-require-terms="true"] .additional-checkout-buttons input', function() {
      var $form = $(this).closest('form');
      if($form.has('#terms') && $form.find('#terms:checked').length == 0) {
        alert(theme.strings.cart_terms_confirmation);
        return false;
      }
    });

    /// Assess footer position on ready/load/resize
    theme.repositionFooter();
    $(window).on('load debouncedresize', theme.repositionFooter);

    /// Product gallery
    $(document).on('initProductGallery', '.product-gallery:not(.product-gallery--init)', function(){
      var $gallery = $(this);
      $gallery.addClass('product-gallery--init');

      var $swiper = $('.swiper-container', this);
      // if multiple slides
      if($swiper.find('.swiper-slide').length > 1) {
        var initial = 0;
        var $feat = $swiper.find('.swiper-slide[data-featured="true"]');
        if($feat.length) {
          initial = $feat.index();
        }

        var swiperOpts = {
          nextButton: $swiper.find('.swiper-button-next'),
          prevButton: $swiper.find('.swiper-button-prev'),
          slidesPerView: 'auto',
          spaceBetween: 10,
          speed: 500,
          autoHeight: $(window).width() < 768, // if true, adjusts the height of the gallery to match the current image
          initialSlide: initial,
          preventClicks: false,
          onTransitionEnd: function(swiper) {
            if($swiper.hasClass('swiper-no-transition-callback')) {
              // triggered by activity inside a slide, do not mess with media
              $swiper.removeClass('swiper-no-transition-callback');
            } else {
              // current slide has changed, process media
              // pause all after change
              $('.product-media').trigger('mediaHidden');
              // play if selected through thumbnail
              var $toPlay = $('.product-media-gallery-selected .product-media', $swiper);
              // play if only one item visible in carousel
              if(!$toPlay.length) {
                var $active = $('.swiper-slide-active', $swiper);
                if(Math.floor($active.width()) == Math.floor($swiper.width())) {
                  $toPlay = $active.find('.product-media');
                }
              }
              $toPlay.trigger('mediaVisible');
              // set view-in-space 3d model
              var $activeModel = $('.swiper-slide-active .product-media--model', $swiper);
              if($activeModel.length) {
                $gallery.find('.view-in-space').attr('data-shopify-model3d-id', $activeModel.data('model-id'));
              }
            }
            // fix tabbing
            theme.productGallerySlideshowTabFix($swiper); // uses & removes class 'product-media-gallery-selected'
          }
        };

        var galleryTop = new Swiper($swiper, swiperOpts);
        galleryTop.slideTo(initial, 0);

        // gallery control
        $(this).on('click', '.gallery-thumbs a', function(e){
          e.preventDefault();
          $swiper.find('.product-gallery__image[data-media-id="' + $(this).data('media-id') + '"]').addClass('product-media-gallery-selected');
          galleryTop.slideTo($(this).index());
        });
      }

      var swipeToSlideIfNotCurrent = function(slideChild) {
        var $slide = $(slideChild).closest('.swiper-slide');
        $slideContainer = $slide.closest('.swiper-container');
        if($slide.offset().left < $slideContainer.offset().left) {
          $slideContainer.addClass('swiper-no-transition-callback').data('swiper').slideTo($slide.index());
        }
      }

      // initialise product media
      theme.ProductMedia.init(this, {
        onPlyrInit: function(playerObj) {
          theme.productGallerySlideshowTabFix($swiper);
        },
        onYoutubeInit: function(playerObj) {
          theme.productGallerySlideshowTabFix($swiper);
        },
        onModelViewerInit: function(element) {
          theme.productGallerySlideshowTabFix($swiper);
        },
        onPlyrPlay: function(playerObj) {
          swipeToSlideIfNotCurrent(playerObj.element);
        },
        onYouTubePlay: function(playerObj) {
          swipeToSlideIfNotCurrent(playerObj.element);
        },
        onModelViewerPlay: function(e) {
          swipeToSlideIfNotCurrent(e.target);
          $(e.target).closest('.swiper-container').addClass('swiper-no-swiping');
        },
        onModelViewerPause: function(e) {
          $(e.target).closest('.swiper-container').removeClass('swiper-no-swiping');
        }
      });

      // init all media now, as multiple media can be seen at once
      $swiper.find('.product-media').trigger('mediaVisibleInitial');
    });

    $(document).on('destroyProductGallery', '.product-gallery', function(){
      $(this).removeClass('product-gallery--init').off('click');
      theme.ProductMedia.destroy(this);
      var swiper = $('.swiper-container', this).data('swiper');
      if(swiper) {
        swiper.destroy();
      }
    });

    /// Tag filtering area
    $(document).on('click', '.filter-group .filter-toggle', function(e){
      e.preventDefault();
      var $group = $(this).closest('.filter-group');
      if($group.toggleClass('filter-group--show').hasClass('filter-group--show')) {
        $group.find('.filter-items').slideDown();
      } else {
        $group.find('.filter-items').slideUp();
      }
    });

    /// Custom share buttons
    $(document).on('click', '.sharing a', function(e){
      var $parent = $(this).parent();
      if($parent.hasClass('twitter')) {
        e.preventDefault();
        var url = $(this).attr('href');
        var width  = 575,
            height = 450,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            opts   = 'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
            ',width='  + width  +
            ',height=' + height +
            ',top='    + top    +
            ',left='   + left;
        window.open(url, 'Twitter', opts);

      } else if($parent.hasClass('facebook')) {
        e.preventDefault();
        var url = $(this).attr('href');
        var width  = 626,
            height = 256,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            opts   = 'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
            ',width='  + width  +
            ',height=' + height +
            ',top='    + top    +
            ',left='   + left;
        window.open(url, 'Facebook', opts);

      } else if($parent.hasClass('pinterest')) {
        e.preventDefault();
        var url = $(this).attr('href');
        var width  = 700,
            height = 550,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            opts   = 'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
            ',width='  + width  +
            ',height=' + height +
            ',top='    + top    +
            ',left='   + left;
        window.open(url, 'Pinterest', opts);

      } else if($parent.hasClass('google')) {
        e.preventDefault();
        var url = $(this).attr('href');
        var width  = 550,
            height = 450,
            left   = ($(window).width()  - width)  / 2,
            top    = ($(window).height() - height) / 2,
            opts   = 'status=1, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0' +
            ',width='  + width  +
            ',height=' + height +
            ',top='    + top    +
            ',left='   + left;
        window.open(url, 'Google+', opts);

      }
    });

    /// Register all sections
    theme.Sections.init();
    theme.Sections.register('header-section', theme.HeaderSection);
    theme.Sections.register('footer-section', theme.FooterSection);
    theme.Sections.register('slideshow', theme.SlideshowSection);
    theme.Sections.register('image-with-text-overlay', theme.ImageWithTextOverlay);
    theme.Sections.register('video', theme.VideoManager);
    theme.Sections.register('map', theme.MapSection);
    theme.Sections.register('custom-row', theme.CustomRowSection);
    theme.Sections.register('featured-product', theme.FeaturedProduct);
    theme.Sections.register('featured-collection', theme.FeaturedCollectionSection);
    theme.Sections.register('featured-collections', theme.FeaturedCollectionsSection);
    theme.Sections.register('collection-template', theme.CollectionTemplateSection);
    theme.Sections.register('list-collections-template', theme.ListCollectionsTemplateSection);
    theme.Sections.register('blog-template', theme.BlogTemplateSection);
    theme.Sections.register('product-template', theme.ProductTemplateSection);
    theme.Sections.register('nested-sections', theme.NestedSectionsSection);


    $('body').each(function(){  
      var highestBox = 0;
      $('.product-block-title', this).each(function(){
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      });  
      $('.product-block-title',this).height(highestBox);

      var highestBox1 = 0;
      $('.productoptions .option-selectors', this).each(function(){
        if($(this).height() > highestBox1) {
          highestBox1 = $(this).height(); 
        }
      });  
      $('.productoptions .option-selectors',this).height(highestBox1);
    }); 

    $('.option-selectors select').change(function(){
      var $form = $(this).closest("form");
      var $option_selectors = $(this).closest('.option-selectors');
      var $os = $form.find('[name="id"]');
      var sel_len = $option_selectors.find('.selector-wrapper').length;
      var opt1 = $option_selectors.find('.selector-wrapper').eq(0).find('select').val();
      var opt2 = $option_selectors.find('.selector-wrapper').eq(1).find('select').val();
      var opt3 = $option_selectors.find('.selector-wrapper').eq(2).find('select').val();
      var variant_title;
      if(sel_len == 1) {
        variant_title = opt1;
      } else if(sel_len == 2) {
        variant_title = opt1 + " / " + opt2;
      }
      else {
        variant_title = opt1 + " / " + opt2 + " / " + opt3;
      }
      
      $os.val($os.find('option[data-title="'+variant_title+'"]').attr('value')).change();
    });

  });//ready

})(theme.jQuery);
